import { render, staticRenderFns } from "./NavbarSubItemContext.vue?vue&type=template&id=3b62fd03&scoped=true"
import script from "./NavbarSubItemContext.vue?vue&type=script&lang=js"
export * from "./NavbarSubItemContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62fd03",
  null
  
)

export default component.exports